import {css} from "@panda/css";

import {Highlight, Text} from "@pg-design/text-module";
import {numberFormat} from "@pg-mono/string-utils";

import {useShouldShowPrice} from "../../hooks/use_should_show_price";
import {getCurrency} from "../../utils/get_currency";
import type {IPropertyDetail} from "../types/IPropertyDetail";
import {_PropertyHighlightPriceM2} from "./_PropertyHighlightPriceM2";

interface IProps {
    property: IPropertyDetail;
    highlight?: boolean;
}

export const PropertyHighlightPrice = (props: IProps) => {
    const shouldShowPrice = useShouldShowPrice({
        offerPriceVisibility: props.property.offer.configuration.price_visibility,
        vendorPriceVisibility: props.property.offer.vendor.configuration.price_visibility,
        vendorId: props.property.offer.vendor.id
    });

    const hasPrice = typeof props.property.price === "number" && props.property.price > 0;
    const hasPriceM2 = props.property.price_m2 > 0;

    const currency = getCurrency({currency: props.property.offer.currency});

    if (!shouldShowPrice) {
        return null;
    }

    if (props.highlight && hasPrice) {
        return (
            <div className={fullPriceStyle}>
                <Highlight>
                    <Text as="span" variant="headline_2">
                        {numberFormat(props.property.price as number)}&nbsp;
                    </Text>
                    <Text as="span" variant="headline_6">
                        {currency}
                    </Text>
                </Highlight>
                {hasPriceM2 && <_PropertyHighlightPriceM2 property={props.property} />}
            </div>
        );
    }

    return hasPrice ? (
        <div className={fullPriceStyle}>
            <div>
                <Text as="span" variant="headline_2">
                    {numberFormat(props.property.price as number)}&nbsp;
                </Text>
                <Text as="span" variant="headline_6">
                    {currency}
                </Text>
            </div>
            {hasPriceM2 && <_PropertyHighlightPriceM2 property={props.property} />}
        </div>
    ) : null;
};

const fullPriceStyle = css({
    backgroundColor: "var(--colors-background-200)",
    paddingX: 1,
    paddingY: 0.5,
    display: "inline-flex",
    alignItems: "center",
    gap: 1,
    maxWidth: "fit-content"
});
import {css} from "@panda/css";

import {Highlight, Text} from "@pg-design/text-module";
import {numberFormat} from "@pg-mono/string-utils";

import {useShouldShowPrice} from "../../hooks/use_should_show_price";
import {getCurrency} from "../../utils/get_currency";
import type {IPropertyDetail} from "../types/IPropertyDetail";
import {_PropertyHighlightPriceM2} from "./_PropertyHighlightPriceM2";

interface IProps {
    property: IPropertyDetail;
    highlight?: boolean;
}

export const PropertyHighlightPrice = (props: IProps) => {
    const shouldShowPrice = useShouldShowPrice({
        offerPriceVisibility: props.property.offer.configuration.price_visibility,
        vendorPriceVisibility: props.property.offer.vendor.configuration.price_visibility,
        vendorId: props.property.offer.vendor.id
    });

    const hasPrice = typeof props.property.price === "number" && props.property.price > 0;
    const hasPriceM2 = props.property.price_m2 > 0;

    const currency = getCurrency({currency: props.property.offer.currency});

    if (!shouldShowPrice) {
        return null;
    }

    if (props.highlight && hasPrice) {
        return (
            <div className={fullPriceStyle}>
                <Highlight>
                    <Text as="span" variant="headline_2">
                        {numberFormat(props.property.price as number)}&nbsp;
                    </Text>
                    <Text as="span" variant="headline_6">
                        {currency}
                    </Text>
                </Highlight>
                {hasPriceM2 && <_PropertyHighlightPriceM2 property={props.property} />}
            </div>
        );
    }

    return hasPrice ? (
        <div className={fullPriceStyle}>
            <div>
                <Text as="span" variant="headline_2">
                    {numberFormat(props.property.price as number)}&nbsp;
                </Text>
                <Text as="span" variant="headline_6">
                    {currency}
                </Text>
            </div>
            {hasPriceM2 && <_PropertyHighlightPriceM2 property={props.property} />}
        </div>
    ) : null;
};

const fullPriceStyle = css({
    backgroundColor: "var(--colors-background-200)",
    paddingX: 1,
    paddingY: 0.5,
    display: "inline-flex",
    alignItems: "center",
    gap: 1,
    maxWidth: "fit-content"
});
